import Vue from 'vue'
import VueRouter from 'vue-router'
import android from '../views/android.vue'
import home from '../views/home.vue'
import ios from '../views/ios.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/android',
    name: 'android',
    component: android
  },
  {
    path: '/ios',
    name: 'ios',
    component: ios
  }
]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
